function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import Box from './Box';
const ListGroup = props => /*#__PURE__*/React.createElement(Box, _extends({}, props, {
  __css: {
    bg: 'white',
    borderRadius: 'corner',
    border: 'default',
    overflow: 'hidden'
  }
}));
ListGroup.propTypes = {};
ListGroup.defaultProps = {};
ListGroup.displayName = 'ListGroup';
export default ListGroup;